module.exports = __webpack_public_path__ + "static/media/owner.8a2cf814.svg";